import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {configUrl} from "config.js";

export default function useIncreaseQuestionSequence() {
  let queryClient = useQueryClient();
  return useMutation( async(props) => {
      await axios.put(
        `${configUrl.AssessmentServer}/api/PoolQuestionMappings/increaseSequence/${props.poolId}/${props.questionId}`
      );
    },
    {
      onSuccess: () => {          
        queryClient.invalidateQueries("questionsByPoolId");
      },
    }
  );
}
